/* eslint-disable vue/multi-word-component-names */
import { createApp, defineAsyncComponent } from 'vue'
import App from './App.vue'

import vue3GoogleLogin from 'vue3-google-login'
// import Vue3GoogleLogin from 'vue3-google-login';
import Multiselect from 'vue-multiselect'
// ELEMENT PLUS — register ONLY the 3 components the app actually uses
// (el-alert / el-button / el-row). Importing the whole framework + its full
// index.css loaded ~framework-scale JS/CSS on every page (incl. login/checkout),
// hurting mobile INP. Partial import lets webpack tree-shake the rest.
import { ElAlert, ElButton, ElRow } from 'element-plus'
import 'element-plus/theme-chalk/base.css'
import 'element-plus/theme-chalk/el-alert.css'
import 'element-plus/theme-chalk/el-button.css'
import 'element-plus/theme-chalk/el-row.css'

// Vuetify
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
// Tree-shaken: only the Vuetify components used in templates are registered (v-avatar,
// v-table, v-btn). <v-pagination> is @hennge/vue3-pagination (registered below); Vuetify's own
// VPagination is NOT registered: it took over every <v-pagination> without a local import and,
// ignoring :pages, always showed one page. Adding a new <v-...> component requires registering it here.
import { VAvatar, VTable, VBtn } from 'vuetify/components'
import { Ripple } from 'vuetify/directives'

import { waUrl } from '@/utils/whatsapp'
import { batchLabel, isRecertBatch } from '@/utils/batch'
import router from './router'
import store from './store'

import VueSocialSharing from 'vue-social-sharing'

//bootstrap
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/js/bootstrap.js'

import './assets/css/main.css'
// import "./assets/css/main.scss";
import './assets/js/js.js'

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { fas } from '@fortawesome/free-solid-svg-icons'
library.add(fas)
import { fab } from '@fortawesome/free-brands-svg-icons'
library.add(fab)
import { far } from '@fortawesome/free-regular-svg-icons'
library.add(far)
import { dom } from '@fortawesome/fontawesome-svg-core'
dom.watch()

import Toast from 'vue-toastification'
// Import the CSS or use your own!
import 'vue-toastification/dist/index.css'

import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'

const options = {
  // You can set your default options here
}

import { LoadingPlugin } from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/css/index.css'
import mixins from './mixins'
import moment from 'moment'

import DateFormat from '@voidsolutions/vue-dateformat'

// lottie, quill, circle-progress are registered as async global components
// further down so their (heavy) JS+CSS code-split out of the main bundle and
// load only on the pages that actually render them.

import VPagination from '@hennge/vue3-pagination'
import '@hennge/vue3-pagination/dist/vue3-pagination.css'

import Vue3EasyDataTable from 'vue3-easy-data-table'
import 'vue3-easy-data-table/dist/style.css'

import { VueTruncateHtml } from 'vue3-truncate-html'

import { VuePicker, VuePickerOption } from '@invisiburu/vue-picker'
import { VueIdentifyNetwork } from 'vue-identify-network'
// optional css
import '@invisiburu/vue-picker/dist/vue-picker.min.css'

import infiniteScroll from 'vue3-infinite-scroll-good'

import 'v-calendar/dist/style.css'
import { Calendar, DatePicker } from 'v-calendar'

import InfiniteLoading from 'v3-infinite-loading'
import 'v3-infinite-loading/lib/style.css'
import { createHead } from '@vueuse/head'

import VueSmoothScroll from 'vue3-smooth-scroll'

import 'vue-material-design-icons/styles.css'
import QuizIcon from 'vue-material-design-icons/HelpBoxMultipleOutline.vue'
import AssignmentIcon from 'vue-material-design-icons/ClipboardTextOutline.vue'
import LockOutlineIcon from 'vue-material-design-icons/LockOutline.vue'
import SchoolOutlineIcon from 'vue-material-design-icons/SchoolOutline.vue'

// import the component
import LvSkeleton from 'lightvue/skeleton'
import LvLoader from 'lightvue/loaders'
import LvCardList from 'lightvue/skeleton/preset/CardList.vue'

const head = createHead()
const app = createApp(App)

app.config.globalProperties.$log = console.log
app.config.globalProperties.$waUrl = waUrl // tagged WhatsApp CS link (src/utils/whatsapp.js)
app.config.globalProperties.$batchLabel = batchLabel // "Batch 7" / "Perpanjangan Sertifikasi" (src/utils/batch.js)
app.config.globalProperties.$isRecertBatch = isRecertBatch
const vuetify = createVuetify({
  components: { VAvatar, VTable, VBtn },
  directives: { Ripple },
})

app.config.globalProperties.$filters = {
  timeAgo(date) {
    return moment(date).fromNow()
  },
}

app.component('quiz-icon', QuizIcon)
app.component('assignment-icon', AssignmentIcon)
app.component('lock-outline-icon', LockOutlineIcon)
app.component('school-outline-icon', SchoolOutlineIcon)
app.use(VueSmoothScroll)
app.component('infinite-loading', InfiniteLoading)
app.component('VPagination', VPagination) // a component, not a plugin: app.use() registered nothing
app.use(infiniteScroll)
app.use(head)
app.component('LvLoader', LvLoader)
app.component('LvSkeleton', LvSkeleton)
app.component('LvCardList', LvCardList)
app.component('VueIdentifyNetwork', VueIdentifyNetwork)
app.component(
  'CircleProgress',
  defineAsyncComponent(() =>
    Promise.all([
      import('vue3-circle-progress'),
      import('vue3-circle-progress/dist/circle-progress.css'),
    ]).then(([m]) => m.default),
  ),
)
app.component('Calendar', Calendar)
app.component('DatePicker', DatePicker)
app.component(
  'QuillEditor',
  defineAsyncComponent(() =>
    Promise.all([
      import('@vueup/vue-quill'),
      import('@vueup/vue-quill/dist/vue-quill.snow.css'),
    ]).then(([m]) => m.QuillEditor),
  ),
)
app.component('EasyDataTable', Vue3EasyDataTable)
app.component('font-awesome-icon', FontAwesomeIcon)
app.component('vue-truncate-html', VueTruncateHtml)
app.component('VuePicker', VuePicker)
app.component('VuePickerOption', VuePickerOption)
app.use(DateFormat)
app.use(LoadingPlugin)
app.mixin(mixins)
app.component('Multiselect', Multiselect)
app.use(VueSocialSharing)
app.use(vue3GoogleLogin, {
  clientId:
    '600394682662-p79muuls9g2sj1vr5hnbn49ndrn45fam.apps.googleusercontent.com',
})
app.component('Vue3GoogleLogin', vue3GoogleLogin)
app.component(
  'Vue3Lottie',
  defineAsyncComponent(() =>
    Promise.all([
      import('vue3-lottie'),
      import('vue3-lottie/dist/style.css'),
    ]).then(([m]) => m.Vue3Lottie),
  ),
)
app.use(VueSweetalert2)
app.use(router)
;[ElAlert, ElButton, ElRow].forEach((c) => app.component(c.name, c))
app.use(Toast, options)
app.use(vuetify)
app.use(store)

app.mount('#app')

// Signal prerenderer that the app is ready
document.dispatchEvent(new Event('render-event'))
